import { IStore } from 'store/configureStore';

export const selectActivitiesState = (state: IStore) =>
    state.modules.settings.clientsSettings.clients.activities;
export const selectIsActivitiesCreating = (state: IStore) =>
    selectActivitiesState(state).isCreating;
export const selectIsActivitiesDeleting = (state: IStore) =>
    selectActivitiesState(state).isDeleting;
